<template>
  <div id="print-manifest" class="print-manifest" v-if="shipment">
    <h4 class="date">Stylist White Glove Manifest</h4>
    <h5>{{ client.shippedDate }}</h5>
    <hr>
    <div class="two-column">
      <div class="address">
        <h4>Shipping From</h4>
        <p>
          {{ address.first_name }} {{ address.last_name }}<br> on behalf of client {{ client.name }}<br>
          {{ address.address_1 }} {{ address.address_2 }}<br>
          {{ address.city }}, {{ address.state }} {{ address.postal_code }}<br>
          {{ address.country }}<br>
          {{ client.email }}
        </p>
      </div>
      <div>
        <h4>Payment Method</h4>
        <p>{{ client.paymentMethod }}</p>
      </div>
    </div>
    <br>
    <h3 class="count">{{ pendingItems.length }} {{ simpleSingularOrPlural(pendingItems.length, 'ITEM', 'ITEMS') }}</h3>
    <hr>
    <br>
    <div v-for="pendingItem in pendingItems" :key="pendingItem.id">
      <div class="two-column">
        <div class="center">
          <div>
            <img width="140" :src="pendingItem.attributes.images.length > 0 ? pendingItem.attributes.images[0].url : placeholderImgUrl"  />
            <h4>{{ pendingItem.attributes.brand }}</h4>
          </div>
        </div>
        <div class="center">
          <div>
            <div v-html="pendingItem.attributes.barCode"></div>
            <p>{{ pendingItem.id }}</p>
          </div>
        </div>
      </div>
      <hr>
    </div>
    <div class="center">
      <div v-html="shipment.attributes.clientBarCode"></div>
    </div>
    <div class="ship-label">
      <h2>Shipping Label</h2>
      <p>Your tracking number is: {{ shipment.attributes.trackingNumber }}.</p>
      <div class="label-image">
        <img :src="shipment.attributes.labelUrl" @load="onLabelLoad">
        <div v-html="shipment.attributes.clientBarCode"></div>
      </div>
    </div>
  </div>
</template>
<script>
import api from '@/services/api'

export default {
  name: 'print',
  data () {
    return {
      shipment: '',
      pendingItems: [],
      placeholderImgUrl: require('@/assets/images/knot.svg'),
      stylist: this.$store.state.stylist
    }
  },
  methods: {
    getQuotes () {
      api.get(this.apiUrl).then(response => {
        const responseArray = response.data
        this.shipment = responseArray.data
        this.pendingItems = responseArray.included
        this.address = responseArray.meta.stylistAddress
        this.client = responseArray.meta.client
        this.$emit('printDataUpdated', responseArray)
      })
    },
    onLabelLoad () {
      this.$emit('isPrintReady', true)
    },
    simpleSingularOrPlural (count, single, plural) {
      return this.$helpers.singularOrPlural(count, single, plural)
    }
  },
  mounted () {
    this.getQuotes()
  },
  computed: {
    apiUrl () {
      const urlSegment = this.$store.state.stylist ? 'stylist' : 'client'
      return '/api/' + urlSegment + '/white-glove-quotes?shipment-id=' + this.$route.params.shipmentId
    }
  }
}
</script>
